export default __webpack_public_path__ + "static/media/img61.13be4405.jpg";